/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	GetPublicationDetailsResponse,
	GetUserTutorialsResponse,
	PublicationEntity,
	RatedPublicationEntity
} from '@kemu-io/kemu-types';
import { RootState } from '../../../app/store';
import { AsyncRequestStatus, AsyncState, RecipeResponse } from '../../../types/core_t';


export interface MarketplaceState {
	userRecipeList: RecipeResponse[];
	userTutorialList: GetUserTutorialsResponse;
	publicRecipeList: RatedPublicationEntity[];
	publishingRecipe: {
		asyncState: AsyncState,
		publishedEntity?: PublicationEntity;
	},
	reviewingPublication: AsyncState;
	unpublishState: {
		asyncState: AsyncState;
		publicationId?: string;
	},
	fetchingState: AsyncState;
	publicationDetails: {
		asyncState: AsyncState,
		details?: GetPublicationDetailsResponse;
	}
}

const initialState: MarketplaceState = {
	reviewingPublication: { status: AsyncRequestStatus.idle },
	fetchingState: { status: AsyncRequestStatus.idle },
	publishingRecipe: { asyncState: { status: AsyncRequestStatus.idle } },
	publicationDetails: { asyncState: { status: AsyncRequestStatus.idle } },
	unpublishState: { asyncState: { status: AsyncRequestStatus.idle } },
	userRecipeList: [],
	userTutorialList: [],
	publicRecipeList: []
};



export const marketplaceSlice = createSlice({
	name: 'marketplace',
	initialState,
	reducers: {
		clearUnpublishEntityId: (state, action: PayloadAction<string>) => {
			state.unpublishState.publicationId = action.payload;
		},

		removeRecipeFromList: (state, action: PayloadAction<string>) => {
			state.userRecipeList = state.userRecipeList.filter(recipe => recipe.id !== action.payload);
		},

		clearPublicationDetails: (state) => {
			state.publicationDetails.asyncState.error = undefined;
			state.publicationDetails.asyncState.status = AsyncRequestStatus.idle;
			state.publicationDetails.details = undefined;
		},

		clearPublishRecipeState: (state) => {
			state.publishingRecipe.asyncState = {
				status: AsyncRequestStatus.idle,
				error: undefined
			};

			state.publishingRecipe.publishedEntity = undefined;
		}
	},

	extraReducers: (builder) => {

	}
});

export const {
	removeRecipeFromList,
	clearPublishRecipeState,
	clearPublicationDetails,
	clearUnpublishEntityId,
} = marketplaceSlice.actions;


export const userRecipeList = (state: RootState): RecipeResponse[] => state.marketplace.userRecipeList;
export const userTutorialList = (state: RootState): GetUserTutorialsResponse => state.marketplace.userTutorialList;
export const publicRecipeList = (state: RootState): RatedPublicationEntity[] => state.marketplace.publicRecipeList;
export const fetchingState = (state: RootState): AsyncState => state.marketplace.fetchingState;
export const publishRecipeState = (state: RootState) => state.marketplace.publishingRecipe;
export const publicationDetails = (state: RootState) => state.marketplace.publicationDetails;
export const publicationReviewState = (state: RootState) => state.marketplace.reviewingPublication;
export const unpublishRecipeState = (state: RootState) => state.marketplace.unpublishState;

export default marketplaceSlice.reducer;
